import { render, staticRenderFns } from "./optional-package.vue?vue&type=template&id=9ca376ea&scoped=true"
import script from "./optional-package.vue?vue&type=script&lang=ts"
export * from "./optional-package.vue?vue&type=script&lang=ts"
import style0 from "./optional-package.vue?vue&type=style&index=0&id=9ca376ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca376ea",
  null
  
)

export default component.exports